import React from 'react';

const Header = () => {
  return (
    <header className="header">
      <h1 className="app-title">Flexbox Visualizer</h1>
      <a href="https://twitter.com/pdbhat07" target="_blank" rel="noopener noreferrer">
        <span className="author">
          <span className="year">&copy; 2020. &rarr;</span>
        Priyadarshan Bhat
      </span>
      </a>
    </header>
  );
}

export default Header;